import {toast} from 'react-toastify';

export const showSuccessMessage = (successMessage: string) =>
  toast.success(successMessage || 'Success', {delay: 20});
